import React, { useState } from "react"
import { ThemeProvider } from "styled-components"

import useVideoTracking from "hooks/useVideoTracking"
import componentThemeExtension from "utils/componentThemeExtension"

import VideoHero from "components/hero/video"
import PopupVideo from "components/popup-video"
import ContentfulButton from "./button"

const ContentfulVideoHero = ({ component, elRef, onTop }) => {
  const {
    heading,
    headingFont,
    subheading,
    backgroundMedia,
    popupVideo,
    featureHighlights,
    ctaButton,
    trackingId,
    id,
    hideOnPageLoad,
    videoSignature,
  } = component

  const [videoPlaying, setVideoPlaying] = useState(false)

  const headText = heading.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")
  const headingProp = {
    text: headingFont !== "mbg Monoline" ? headText : null,
    monolineText: headingFont === "mbg Monoline" ? headText : null,
  }

  const { trackVideoView, trackVideoProgress } = useVideoTracking()
  if (trackingId) {
    trackVideoView(elRef, trackingId)
  }
  const progressTracker = trackVideoProgress(trackingId)

  return (
    <ThemeProvider theme={componentThemeExtension("Light Background Primary", false, onTop)}>
      {videoPlaying && (
        <PopupVideo
          videoId={popupVideo ? popupVideo[0]?.secure_url : videoSignature}
          onPercentViewed={progressTracker}
          onCloseModal={() => setVideoPlaying(false)}
        />
      )}
      <VideoHero
        hideOnPageLoad={hideOnPageLoad}
        dataId={id}
        elRef={elRef}
        variant={featureHighlights || ctaButton ? "Large" : "Small"}
        heading={headingProp}
        subheading={subheading && subheading.childMarkdownRemark.html}
        backgroundImage={
          backgroundMedia &&
          backgroundMedia[0].resource_type === "image" &&
          backgroundMedia[0].secure_url
        }
        backgroundVideo={
          backgroundMedia &&
          backgroundMedia[0].resource_type === "video" &&
          backgroundMedia[0].secure_url
        }
        buttonElement={ctaButton && <ContentfulButton component={ctaButton} />}
        onClick={() => setVideoPlaying(true)}
        featureHighlights={
          featureHighlights &&
          featureHighlights.map((feat) => ({
            ...feat,
            image: feat.image && {
              url: feat.image[0].secure_url,
              aspect: feat.image[0].height / feat.image[0].width,
            },
          }))
        }
      />
    </ThemeProvider>
  )
}

export default ContentfulVideoHero
